import { REGION_FIELD_DATA } from '~/consts/generalSettings';
import { RegionAttribute } from '~/definitions/region';

function getSelectedRegionAttribute(attributes: RegionAttribute[], number?: string): RegionAttribute {
    let attribute: RegionAttribute = {};
    const field = REGION_FIELD_DATA?.[number as string] || {};

    const attributeFiltered = attributes?.filter((attr: RegionAttribute) => {
        return attr.number === field.name;
    });
    attribute = attributeFiltered?.[0] || {};

    return attribute;
}

export default getSelectedRegionAttribute;
